module.exports = __webpack_public_path__ + "static/media/navDoc.577c80d1.svg";